import { Typography } from 'antd';
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { CloseOutlined } from '@ant-design/icons';
import { useDrawer } from '@/hooks/drawer.hook';
import { BannerSliderTabs } from '../tabs/banner-slider.tabs';
export const BannerSliderDrawer = () => {
  const { closeDrawer } = useDrawer();
  return (
    <div css={rootStyle}>
      <Typography.Title css={titleStyles} level={5}>
        Sắp xếp thứ tự hiển thị banner ở Trang chủ
      </Typography.Title>
      <p css={subTitleStyle}>
        Kéo thả lên xuống để sắp xếp thử tự hiển thị và bấm cập nhật để lưu{' '}
        <br></br> các vị trí hiển thị
      </p>
      <div css={iconStyle} onClick={() => closeDrawer()}>
        <CloseOutlined />
      </div>
      <BannerSliderTabs />
    </div>
  );
};

const titleStyles = css`
  margin-bottom: 0 !important;
  line-height: 3.2rem !important;
  padding: 1.6rem 0;
`;

const subTitleStyle = css`
  font-size: 1.4rem;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  margin: 1.4rem 0;
`;

const iconStyle = css`
  position: absolute;
  top: 5%;
  right: 0;
  cursor: pointer;
  .anticon-close {
    font-size: 2rem;
  }
`;

const rootStyle = css`
  position: relative;
  z-index: 1000;
`;
